import type { Community } from '@communities/community/domain';
import { GET_COMMUNITY } from '@communities/community/graphql';
import { getApolloClient } from '@core/apollo/client';
import type { LoaderFunctionArgs } from 'react-router-dom';

interface CommunityLoaderData {
  community: Community;
}

/**
 * Loader for community routes
 * Fetches community data before rendering the page
 */
export async function communityLoader({ params }: LoaderFunctionArgs): Promise<CommunityLoaderData> {
  const client = getApolloClient();

  const { data } = await client.query<{ community: Community }>({
    query: GET_COMMUNITY,
    variables: { id: params.communityId },
    fetchPolicy: 'cache-first',
  });

  return { community: data.community };
}
